// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import {
    GridColDef,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
    GridExpandMoreIcon,
} from "@mui/x-data-grid";
import { Button, Loading } from "../../atoms";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { downloadExcel } from "../../../util/downloadExcel";
import {
    useGetDailyBankAccountHistory
} from "../../../hooks";

import {
    FormControl,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    Table,
    DateTimePickerControl
} from "../../molecules";
import { zodResolver } from "@hookform/resolvers/zod";
import dayjs from "dayjs";
import { DailyBankAccountHistoryValuesType, merchantTotalTransactionFormSchema, merchantTotalTransactionInitialValues } from "./_formTypes";
import { convertTableFiltersToRequestFilter } from '../../../util/requestFilterHelper';

export const DailyAccountHistoryFilter = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const [isPageLoading, setIsPageLoading] = useState(true);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25
    });

    const { mutate: getDailyBankAccountHistory, isLoading: isDailyBankAccountHistoryLoading } = useGetDailyBankAccountHistory();

    const { control, handleSubmit, setValue, getValues } =
        useForm<DailyBankAccountHistoryValuesType>({
            resolver: zodResolver(merchantTotalTransactionFormSchema),
            defaultValues: merchantTotalTransactionInitialValues,
        });

    const monthList = [
        {
            key: 1,
            value: 'Ocak'
        },
        {
            key: 2,
            value: 'Şubat'
        },
        {
            key: 3,
            value: 'Mart'
        },
        {
            key: 4,
            value: 'Nisan'
        },
        {
            key: 5,
            value: 'Mayıs'
        },
        {
            key: 6,
            value: 'Haziran'
        },
        {
            key: 7,
            value: 'Temmuz'
        },
        {
            key: 8,
            value: 'Ağustos'
        },
        {
            key: 9,
            value: 'Eylül'
        },
        {
            key: 10,
            value: 'Ekim'
        },
        {
            key: 11,
            value: 'Kasım'
        },
        {
            key: 12,
            value: 'Aralık'
        }
    ];

    const yearList = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2000;
        const years = [];

        for (let year = startYear; year <= currentYear; year++) {
            years.push({
                key: year,
                label: year.toString()
            });
        }

        return years.reverse();
    }, []);

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const [showTable, setShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isFilterAccordionExpanded, setIsFilterAccordionExpanded] = useState(true);
    const [dynamicFilters, setDyanamicFilters] = useState([]);

    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);

    const onExport = () => {
        function fieldValue(data) {
            return data.map((item) => {
                return {
                    "Ödeme Tarihi": item?.paymentBankDate ? dayjs(item.paymentBankDate).format('DD.MM.YYYY') : "",
                    "İşlem Toplamı": item?.totalAmount ? `${parseFloat(item.totalAmount).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "",
                    "Üye İşyeri Sayısı": item?.merchantCount,
                };
            });
        }

        getDailyBankAccountHistory({
            month: selectedMonth,
            year: selectedYear,
            filters: [
                ...dynamicFilters
            ] // Handle dynamic filters
        }, {
            onSuccess: (result) => {
                const refactoredData = fieldValue(result?.data);
                downloadExcel(refactoredData || [], "İşyeri başarılı işlemler", null);
                return;
            },
            onError: (result) => {
            }
        })
    }

    const getDailyBankAccountHistoryOnSubmit = (data: DailyBankAccountHistoryValuesType) => {
        setTableData(undefined);
        setIsPageLoading(true);
        setIsFormSubmitted(true);

        getDailyBankAccountHistory({
            month: selectedMonth,
            year: selectedYear,
            filters: [
                ...dynamicFilters
            ] // Handle dynamic filters
        }, {
            onSuccess: (result) => {
                setTableData(result?.data);
                setIsFilterAccordionExpanded(false);
                setShowTable(true);
                setIsPageLoading(false);
            },
            onError: (result) => {

            }
        })
    }

    useEffect(() => {

        if (!isFormSubmitted) return;

        getDailyBankAccountHistoryOnSubmit();
    }, [paginationModel.page, paginationModel.pageSize, queryOptions])

    const getQueryParams = (filters) => {
        const queryParams = {};

        for (let key in filters) {
            if (filters[key]?.toString()?.length >= 1) {
                queryParams[key] = filters[key];
            }
        }

        return queryParams;
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            localStorage.removeItem('dailyBankAccountHistory')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key, value) => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }


        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
        //     return;
        // }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDyanamicFilters(convertTableFiltersToRequestFilter(tableFilters, columns));
            localStorage.setItem('dailyBankAccountHistory', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;
        setPaginationModel({
            page: 0,
            pageSize: paginationModel.pageSize
        });
    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    const previousQueryParams = React.useRef({});


    const columns: GridColDef[] = useMemo(() => {
        return [


            { field: "paymentBankDate", headerName: "Ödeme Tarihi", width: 200, renderCell: (params) => { return params.value ? dayjs(params.value).format('DD.MM.YYYY') : '-' }, filterable: false },
            {
                field: "totalAmount", headerName: "İşlem Toplamı", flex: 1, width: 200, renderCell: (params) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${parseFloat(params.value).toLocaleString("tr-TR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} TL`;
                },
                filterable: false
            },
            { field: "merchantCount", headerName: "Üye İşyeri Sayısı", width: 200, filterable: false },
        ];
    });

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    const isLoading = isDailyBankAccountHistoryLoading;

    return (
        <>
            {isLoading && <Loading />}
            <Stack flex={1} justifyContent={'space-between'}>
                <Stack flex={1} p={2}>
                    <BaseFilterTableWithAccordion summary="Günlük Hesap Hareketleri" isExpanded={isFilterAccordionExpanded} setExpanded={setIsFilterAccordionExpanded} setTableVisibility={setShowTable}
                        child={<Stack spacing={4}>
                            <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} width={isDesktop ? '100%' : 'auto'}>
                                <FormControl sx={{ flex: 1 }}>
                                    <Controller
                                        control={control}
                                        name="merchantId"
                                        render={({ field, fieldState }) => {
                                            return (
                                                <Autocomplete
                                                    sx={{ mr: isDesktop ? 2 : 0 }}
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedYear(selectedValue?.key);
                                                        field.onChange(selectedValue?.value || 0);
                                                    }}
                                                    id="merchantId"
                                                    options={yearList}
                                                    getOptionLabel={(option: {
                                                        key: string;
                                                        value: number;
                                                    }) => option.key}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Yıl"
                                                            error={fieldState.invalid}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            );
                                        }}
                                    />
                                </FormControl>
                                <FormControl sx={{ flex: 1 }}>
                                    <Controller
                                        control={control}
                                        name="month"
                                        render={({ field, fieldState }) => {
                                            return (
                                                <Autocomplete
                                                    sx={{ mr: isDesktop ? 2 : 0 }}
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedMonth(selectedValue?.key);
                                                        field.onChange(selectedValue?.value || 0);
                                                    }}
                                                    id="month"
                                                    options={monthList}
                                                    getOptionLabel={(option: {
                                                        key: string;
                                                        value: number;
                                                    }) => `${option.key} ${option.value}`}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Ay"
                                                            error={fieldState.invalid}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            );
                                        }}
                                    />
                                </FormControl>
                                <Stack>
                                    <Button
                                        onClick={getDailyBankAccountHistoryOnSubmit}
                                        variant="contained"
                                        text={"Ara"}
                                        disabled={isDailyBankAccountHistoryLoading}
                                    />
                                </Stack>
                            </Stack>
                        </Stack>} />
                    <Stack flex={1} mt={2}  >
                        {showTable && (
                            <>
                                <Table
                                    getRowId={() => { return Math.random(100000) }}
                                    isMasterDetailActive={false}
                                    isRowExpandable={false}
                                    columnVisibilityConfigKey="dailyBankAccountHistoryVisibilityKey"
                                    filterKey="dailyBankAccountHistory"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={handleChangePagination}
                                    paginationMode="server"
                                    rowCount={0}
                                    isRowSelectable={() => false}
                                    rows={tableData || []}
                                    customLabelDisplayedRows={true}
                                    getRowClassName={(params) => {
                                        if (params.row.merchantStatus === "PASSIVE" || params.row.merchantStatus === "BLOCKED") {
                                            return "merchant-passive-row";
                                        } else {
                                            return '';
                                        }
                                    }}
                                    autoHeight={false}
                                    columns={columns}
                                    exportFileName="Günlük Hesap Hareketleri"
                                    onSave={() => onExport()}
                                />
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}